import { Dialog, Button } from '@mui/material';

interface OneBtnAlertProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
  btnText?: string;
  onClick: () => void;
  children?: React.ReactNode;
}

export default function OneBtnAlert({
  open,
  onClose,
  title,
  description,
  btnText = 'Confirm',
  onClick,
  children,
}: OneBtnAlertProps) {
  return (
    <Dialog
      open={open}
      onClose={(reason: any) => {
        if (reason === 'backdropClick') return;
        onClose();
      }}
      PaperProps={{
        sx: {
          borderRadius: '16px',
          maxWidth: 'calc(100vw - 40px)',
          width: '100%',
          margin: '20px',
        },
      }}
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
        zIndex: 9999,
      }}
    >
      <div className="w-full bg-white rounded-[16px] p-[24px] flex flex-col gap-[32px]">
        <div className="w-full flex flex-col items-center justify-center gap-[12px]">
          <div className="text-[20px] font-[700] text-center text-[#1C1C1C] leading-[1.3] break-keep whitespace-pre-wrap">
            {title.split('\n').map((line, i) => (
              <span key={i}>
                {line}
                {i === 0 && <br />}
              </span>
            ))}
          </div>
          <div className="text-[14px] font-[400] text-center text-[#363636] leading-[1.6] break-keep whitespace-pre-wrap">
            {description.split('\n').map((line, i) => (
              <span key={i}>
                {line}
                {i === 0 && <br />}
              </span>
            ))}
          </div>
        </div>
        {children && <div className="w-full">{children}</div>}
        <Button variant="contained" onClick={onClick} className="w-full h-[48px] rounded-[8px]">
          {btnText}
        </Button>
      </div>
    </Dialog>
  );
}
